// Вкладка «Структура»: партнёр → рекламодатель → бренд → кампании.
export const ENTITY_KIND = Object.freeze({
    PARTNER: 'partner',
    ADVERTISER: 'advertiser',
    BRAND: 'brand',
});

/** Служебные узлы дерева для сущностей без родителя (видны только admin). */
export const GROUP_KIND = Object.freeze({
    NO_PARTNER: 'no-partner',
    NO_ADVERTISER: 'no-advertiser',
});

export const ENTITY_LABEL = Object.freeze({
    [ENTITY_KIND.PARTNER]: { one: 'Партнёр', accusative: 'партнёра' },
    [ENTITY_KIND.ADVERTISER]: { one: 'Рекламодатель', accusative: 'рекламодателя' },
    [ENTITY_KIND.BRAND]: { one: 'Бренд', accusative: 'бренд' },
});

export const ENTITY_ENDPOINT = Object.freeze({
    [ENTITY_KIND.PARTNER]: '/administration/partners',
    [ENTITY_KIND.ADVERTISER]: '/administration/advertiser-brand/advertisers',
    [ENTITY_KIND.BRAND]: '/administration/advertiser-brand/brands',
});

/** Ключ коллекции в data.structure для каждого вида сущности. */
export const ENTITY_COLLECTION = Object.freeze({
    [ENTITY_KIND.PARTNER]: 'partners',
    [ENTITY_KIND.ADVERTISER]: 'advertisers',
    [ENTITY_KIND.BRAND]: 'brands',
});

// Зеркало App\Http\Resources\Structure\CampaignNodeResource::TYPE_*.
export const CAMPAIGN_TYPE = Object.freeze({
    GUARANTEED: 'guaranteed',
    RTB: 'rtb',
    RTB_PACKAGE: 'rtb_package',
    RTB_POI: 'rtb_poi',
});

export const CAMPAIGN_TYPE_LABEL = Object.freeze({
    [CAMPAIGN_TYPE.GUARANTEED]: 'Гарант.',
    [CAMPAIGN_TYPE.RTB]: 'RTB',
    [CAMPAIGN_TYPE.RTB_PACKAGE]: 'RTB-пакет',
    [CAMPAIGN_TYPE.RTB_POI]: 'POI',
});

export const STRUCTURE_ACTION = Object.freeze({
    CREATE_ADVERTISER: 'create-advertiser',
    CREATE_BRAND: 'create-brand',
    EDIT: 'edit',
    EDIT_MARKUP: 'edit-markup',
    DELETE: 'delete',
});

export const DEFAULT_PARTNER_MARKUP_PERCENT = 15;

// Зеркало App\Enums\MarkupTarget: дефолт партнёра и переопределение RTB-кампании (включая пакетные).
export const MARKUP_TARGET = Object.freeze({
    PARTNER: 'partner',
    CAMPAIGN_RTB: 'campaign_rtb',
});

/** Поля уровней в markup-объектах API; platform_percent приходит только admin. */
export const MARKUP_LEVEL = Object.freeze({
    PLATFORM: 'platform_percent',
    AGENCY: 'agency_percent',
});

export const MARKUP_LEVEL_LABEL = Object.freeze({
    [MARKUP_LEVEL.PLATFORM]: { short: 'L1', full: 'Платформенная наценка (L1)' },
    [MARKUP_LEVEL.AGENCY]: { short: 'L2', full: 'Агентская наценка (L2)' },
});

/** Ability партнёра, разрешающая править уровень. */
export const MARKUP_LEVEL_ABILITY = Object.freeze({
    [MARKUP_LEVEL.PLATFORM]: 'edit_platform_markup',
    [MARKUP_LEVEL.AGENCY]: 'edit_agency_markup',
});

export const MARKUP_ENDPOINT = '/administration/markups';

export const MAX_MARKUP_PERCENT = 999.99;
